import { Directive, HostListener, Input } from '@angular/core';

/**
 * A size in whole millimetres: a decimal point or comma cannot be typed, and no number in
 * the field gets more digits than `maxDigits`. A formula like `600+18` stays possible.
 */
@Directive({ selector: '[appWholeMillimetres]' })
export class WholeMillimetresDirective {
	@Input() maxDigits = 5;

	@HostListener('beforeinput', ['$event'])
	refuseDecimals(event: InputEvent) {
		if (event.inputType === 'insertText' && /[.,]/.test(event.data ?? '')) {
			event.preventDefault();
		}
	}

	@HostListener('input', ['$event'])
	capDigits(event: Event) {
		const input = event.target as HTMLInputElement;
		const capped = input.value.replace(/\d+/g, (run) => run.slice(0, this.maxDigits));
		if (capped !== input.value) {
			input.value = capped;
			input.dispatchEvent(new Event('input', { bubbles: true }));
		}
	}
}
